// PDP Variant Swatches - TSS-012

// Track if already initialized to prevent duplicate initialization
let isInitialized = false;

/**
 * Initialize PDP variant swatches functionality
 */
function initPDPVariantSwatches() {
  if (isInitialized) {
    console.log('TSS-012 PDP: Already initialized, skipping');
    return;
  }

  console.log('TSS-012 PDP: Initializing');

  const container = document.querySelector('.pdp-variant-swatches--tss-012');
  if (!container) {
    console.log('TSS-012 PDP: Container not found');
    return;
  }

  console.log('TSS-012 PDP: Container found', container);
  
  isInitialized = true;

  const swatches = container.querySelectorAll('.pdp-variant-swatches--tss-012__swatch');
  console.log('TSS-012 PDP: Found', swatches.length, 'swatches');
  
  swatches.forEach(swatch => {
    swatch.addEventListener('click', function(e) {
      e.preventDefault();
      
      console.log('TSS-012 PDP: Swatch clicked', {
        disabled: this.disabled,
        isSelected: this.closest('.pdp-variant-swatches--tss-012__item').classList.contains('pdp-variant-swatches--tss-012__item--selected'),
        variantUrl: this.dataset.variantUrl
      });
      
      // Don't do anything if disabled or already selected
      if (this.disabled || this.closest('.pdp-variant-swatches--tss-012__item').classList.contains('pdp-variant-swatches--tss-012__item--selected')) {
        console.log('TSS-012 PDP: Swatch is disabled or already selected, skipping');
        return;
      }

      const variantUrl = this.dataset.variantUrl;
      const variantTitle = this.getAttribute('aria-label');
      
      if (!variantUrl) {
        console.error('TSS-012 PDP: No variant URL found');
        return;
      }

      console.log('TSS-012 PDP: Navigating to', variantUrl);
      
      // Navigate to the variant product page
      window.location.href = variantUrl;
      
      // Announce to screen readers
      announceVariantChange(variantTitle);
    });

    // Keyboard support
    swatch.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });

  /**
   * Announce variant change to screen readers
   */
  function announceVariantChange(variantTitle) {
    let liveRegion = document.getElementById('tss-012-pdp-live-region');
    
    if (!liveRegion) {
      liveRegion = document.createElement('div');
      liveRegion.id = 'tss-012-pdp-live-region';
      liveRegion.setAttribute('role', 'status');
      liveRegion.setAttribute('aria-live', 'polite');
      liveRegion.setAttribute('aria-atomic', 'true');
      liveRegion.className = 'visually-hidden';
      document.body.appendChild(liveRegion);
    }
    
    liveRegion.textContent = `Navigating to ${variantTitle}`;
    
    // Clear after announcement
    setTimeout(() => {
      liveRegion.textContent = '';
    }, 1000);
  }
}

/**
 * Wait for Intelligems to add TSS-012 class to body
 */
function waitForIntelligems(retryCount = 0) {
  const maxRetries = 3;
  const timeoutDuration = 10000; // 10 seconds
  
  console.log('TSS-012 PDP: Waiting for Intelligems to add TSS-012 class (attempt ' + (retryCount + 1) + ')');

  // Check if class already exists
  if (document.body.classList.contains('TSS-012')) {
    console.log('TSS-012 PDP: TSS-012 class found immediately');
    initPDPVariantSwatches();
    return;
  }

  // Set up MutationObserver to watch for class changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        if (document.body.classList.contains('TSS-012')) {
          console.log('TSS-012 PDP: TSS-012 class detected via MutationObserver');
          observer.disconnect();
          initPDPVariantSwatches();
        }
      }
    });
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  // Fallback timeout - check one more time then optionally retry
  setTimeout(() => {
    observer.disconnect();
    
    // Final check after timeout
    if (document.body.classList.contains('TSS-012')) {
      console.log('TSS-012 PDP: TSS-012 class found after timeout');
      initPDPVariantSwatches();
    } else if (retryCount < maxRetries) {
      console.log('TSS-012 PDP: Timeout reached, retrying...');
      waitForIntelligems(retryCount + 1);
    } else {
      console.warn('TSS-012 PDP: Max retries reached, TSS-012 class not found - initialization skipped');
    }
  }, timeoutDuration);
}

// Start when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForIntelligems);
} else {
  waitForIntelligems();
}

// Handle page restoration from bfcache (back/forward navigation)
window.addEventListener('pageshow', (e) => {
  if (e.persisted) {
    // Page restored from bfcache - reset and re-initialize swatches
    console.log('TSS-012 PDP: Page restored from bfcache, re-initializing');
    isInitialized = false;
    waitForIntelligems();
  }
});
